import React from 'react';
import { Global } from '@emotion/react';
import { cssReset } from 'ui_system/token_auth/styles_root';
import { Container, H1, BareHR, BodyText } from './PrivacyStyles';
import { Logo } from './logo';

const PrivacyVerificationSuccess = () => {
  const params = new URLSearchParams(window.location.search);
  const request_token_id = params.get('confirmation');
  return (
    <React.Fragment>
      <Global styles={cssReset({})} />
      <Logo />
      <BareHR />
      <Container>
        <H1>Your request is confirmed!</H1>
        <BodyText>
          Your email has been successfully verified. Our team will review your
          request and follow up with you via email. Your request ID is{' '}
          <strong>{request_token_id}</strong>.
        </BodyText>
        <BodyText>Please keep this for your records.</BodyText>
      </Container>
    </React.Fragment>
  );
};

export default PrivacyVerificationSuccess;
